import { createFileRoute } from "@tanstack/react-router"

// Import the existing campaign list page
import CampaignList from "@/pages/jobs/campaigns/list-page"

export const Route = createFileRoute("/_screen/campaign/list")({
  component: CampaignListPage
})

function CampaignListPage() {
  return <CampaignList />
}
